import { View, type StyleProp, type ViewStyle } from "react-native";
import { ChevronDown, ChevronUp } from "lucide-react-native";
import { semanticColors } from "@louise/theme/tokens";

type CollapsibleChevronButtonProps = {
  expanded: boolean;
  size?: number;
  iconSize?: number;
  color?: string;
  strokeWidth?: number;
  backgroundColor?: string;
  borderColor?: string;
  style?: StyleProp<ViewStyle>;
};

export function CollapsibleChevronButton({
  expanded,
  size = 28,
  iconSize = 15,
  color = semanticColors.text.tertiary,
  strokeWidth = 2,
  backgroundColor = semanticColors.action.quiet.background,
  borderColor = semanticColors.action.quiet.border,
  style,
}: CollapsibleChevronButtonProps) {
  const ChevronIcon = expanded ? ChevronUp : ChevronDown;

  return (
    <View
      style={[
        {
          width: size,
          height: size,
          borderRadius: 999,
          alignItems: "center",
          justifyContent: "center",
          backgroundColor,
          borderWidth: 1,
          borderColor,
          flexShrink: 0,
        },
        style,
      ]}
    >
      <ChevronIcon size={iconSize} color={color} strokeWidth={strokeWidth} />
    </View>
  );
}
